<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="invoicePolicyList"
      :pagination.sync="pagination"
      :hide-default-footer="true"
    >
      <template v-slot:item="props">
        <tr >
          <td style="width:30%;">
            <p>{{props.item.name}}</p>
          </td>
          <td style="width:30%;">
            <p>{{props.item.user.id + " " + props.item.user.name}}</p>
          </td>
          <td style="width:30%;">
            <p>{{props.item.short_name}}</p>
          </td>
          <td style="width:30%;">
            <p>{{props.item.enabled}}</p>
          </td>
           <td style="width:30%;">
            <v-row>
              <v-btn x-small @click="edit(props.item)">Edit</v-btn>
              <v-btn x-small @click="showProcessAllInvoices(props.item.id)">Process All Invoices</v-btn>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Process Invoices</v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn class="text-none" flat text @click="dialog = false">Close</v-btn>
          <v-btn class="text-none" flat text @click="dialog = false; processInvoices()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "invoice_policy_list",
  components: {},
  props: {
    invoicePolicyList: Array,
    paginationProp: Object
  },
  mounted: async function() {},
  data: function() {
    return {
      id: null,
      dialog: false,
      message: "",
      pagination: this.paginationProp,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "User",
          align: "left",
          sortable: false,
          value: "user"
        },
        {
          text: "Short Name",
          align: "left",
          sortable: false,
          value: "user"
        },
        {
          text: "Enabled",
          align: "left",
          sortable: false,
          value: "user"
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "user"
        },
      ]
    };
  },
  methods: {
    edit: function(invoicePolicy) {
      this.$emit("select", invoicePolicy);
    },
    showProcessAllInvoices: function(id) {
      this.id = id;
      this.dialog = true;
    },
    processInvoices: async function() {
      this.dialog = false;

      var vm = this;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/account_invoice_policy/markAllAsProcessed/${this.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        if (response.data.error == "no_error") {
          alert(response.data.count + " Invoices processed")
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown error");
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
